module.exports = __webpack_public_path__ + "static/media/transition_02.d036bec5.mp3";